import React from 'react';
import { BaseLayout } from '@/components/layout';
import CalendlyWidget from '@/components/shared/CalendlyWidget';

const ScheduleVisit: React.FC = () => {
  return (
    <BaseLayout>
      <div className="p-4 sm:p-6 lg:p-8">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-2xl sm:text-3xl font-bold text-foreground">
            Schedule a Visit
          </h1>
          <p className="mt-2 text-muted-foreground">
            Choose a convenient time to schedule a visit with our team
          </p>
        </div>

        {/* Calendly Widget */}
        <div className="bg-card rounded-lg shadow-sm border border-border overflow-hidden">
          <CalendlyWidget
            style={{
              height: 'calc(100vh - 280px)',
              minHeight: '600px',
            }}
          />
        </div>
      </div>
    </BaseLayout>
  );
};

export default ScheduleVisit;
